import { ArrowUp } from "phosphor-react";
import React, { useEffect, useState } from "react";

export default function BackToTopButton() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Show/hide the back to top button based on scroll position
    if (scrollTop > 150) {
      setShowBackToTop(true);
    } else {
      setShowBackToTop(false);
    }
  };

  // Attach scroll event listener on component mount
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {showBackToTop && (
        <button
          className="fixed bottom-6 left-6 text-white bg-tertiary rounded-full p-2 shadow-lg"
          onClick={handleScrollToTop}
        >
          <ArrowUp size={24} weight="bold" />
        </button>
      )}
    </>
  );
}
